<template>
  <div class="content">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex"></div>
      <div class="top-button-group">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mr-2" @click="add" x-small right color="primary"><v-icon small>mdi-plus-circle-outline</v-icon></v-btn>
          </template>
          <span>{{ $t('common.add') }}</span>
        </v-tooltip>
      </div>
    </v-card>
    <v-data-table ref="list" dense :headers="headers" :items="datasources" item-key="name" :loading="loading" class="elevation-1" hide-default-footer>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small @click="edit(item)" class="mr-2" color="primary">mdi-pencil-box-multiple-outline</v-icon>
          </template>
          <span>{{ $t('common.edit') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small @click="remove(item)" color="primary">mdi-trash-can-outline</v-icon>
          </template>
          <span>{{ $t('common.delete') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <component v-bind:is="component" :values="values" v-model="showForm" @insert="onInsert" />
  </div>
</template>

<script>
import { api } from '@/api/common/instances';

export default {
  data() {
    return {
      showForm: false,
      loading: true,
      component: null,
      datasources: [],
      values: null,
    };
  },
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
    headers() {
      return [
        { text: this.$t('datasource.name'), value: 'name', sortable: false },
        { text: this.$t('datasource.jdbcUrl'), value: 'jdbcUrl', sortable: false },
        { text: this.$t('datasource.username'), value: 'username', sortable: false },
        { text: this.$t('datasource.password'), value: 'password', sortable: false },
        { text: this.$t('datasource.maximumPoolSize'), value: 'maximumPoolSize', sortable: false, width: '80px' },
        { text: this.$t('datasource.targets'), value: 'targets', sortable: false, width: '110px' },
        { text: '', value: 'actions', sortable: false, width: '80px' },
      ];
    },
  },
  methods: {
    async add() {
      this.values = {};
      this.component = (await import(`./DatasourceForm.vue`)).default;
      this.showForm = true;
    },
    async edit(item) {
      this.values = item;
      this.component = (await import(`./DatasourceForm.vue`)).default;
      this.showForm = true;
    },
    async remove(item) {
      if (await this.$dialog.confirm(this.$t('common.delete.q'))) {
        this.loading = true;
        const response = await api.delete(`/preference/datasources/${item.name}`);
        if (response.status == 200) {
          const index = this.datasources.findIndex(d => d.name == item.name);
          this.datasources.splice(index, 1);
        }
        this.loading = false;
      }
    },
    async getData() {
      this.loading = true;
      this.datasources = (await api.get('/preference/datasources')).data;
      this.loading = false;
    },
    onInsert(item) {
      this.datasources.push(item);
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.content {
  min-width: 950px;
  min-height: 300px;
}
</style>
